<template lang="pug">
  transition(name='fade')
    b-card.ls-organization-item.card-white.card-no-gutters.shadow(no-body)
      b-card-body.d-flex
        b-link.stretched-link(v-if='actionItemClicked' @click.stop.prevent='itemClicked')

        b-avatar.wc-bubble.wc-bubble-md.wc-bubble-br.wc-bubble-linked.shadow.mr-4(
          :src='item.attributes.portrait_url'
          variant='white'
          alt='')
          template(v-if='!item.attributes.portrait_url' #default)
            .wc-bubble-content.wc-bubble-linked.bg-primary
              .i-wrapper
                i.fal.fa-fw.fa-2x.fa-building.text-white

        .d-flex.flex-column.flex-fill
          .info.d-flex.flex-column.justify-content-center.flex-grow-1.my-3
            .name.font-weight-bold
              | {{ item.attributes.name }}
            .username.small.text-muted.text-break(v-if="$getDeep(rs.identity, 'attributes.username')")
              | @{{ $getDeep(rs.identity, 'attributes.username') }}

          .d-flex.justify-content-between.align-items-end
            .role
              i.fal.fa-fw.fa-user.text-primary.mr-2
              span.small.text-body
                template(v-for='(role, index) in item.attributes.roles_account')
                  span(v-if='index')
                    | ,&nbsp;
                  | {{ $t(`role.codes.${role}`) }}

            .state
              b-badge.state.p-2(
                :variant="$wc.conf.states.organization.variants[item.attributes.state]"
                pill)
                i.fa-fw(:class="$wc.conf.states.organization.icons[item.attributes.state]")
                |  {{ $t('organization.states.' + item.attributes.state) }}

        .menu.position-absolute
          b-dropdown.ls-organization-item-menu(
            toggle-tag='div'
            toggle-class='p-0 text-muted shadow-none'
            variant='transparent'
            menu-class='border-0 p-0'
            right
            no-caret)
            template(#button-content)
              i.fal.fa-fw.fa-2x.fa-ellipsis-h.text-muted
            b-dropdown-item(
              v-if="$store.getters['auth/currentOrganization'].sid !== item.attributes.sid"
              link-class='py-3'
              @click.stop.prevent='itemSwitch')
              i.fal.fa-fw.fa-repeat.text-muted
              |  {{ $t('organization.menus.switch_organization') }}
</template>

<script>
export default {
  name: 'ls-organization-item',
  props: {
    index: Number,
    item: Object,
    rs: Object,
    actionItemClicked: String,
    actionDelete: Boolean,
  },
  methods: {
    itemClicked(event) {
      if (this.actionItemClicked) this.$emit('item-clicked', this.item, this.index, event)
    },
    async itemSwitch() {
      await this.$store.dispatch('auth/setCurrentOrganization', this.item.attributes.sid)
      this.$router.push({ path: '/' })
    },
  },
}
</script>

<style lang="scss">
.ls-organization-item {
  min-height: 11rem;
  .menu {
    top: 1rem;
    right: 1rem;
    z-index: 1;
  }
}
</style>
